import { render, staticRenderFns } from "./BDatePickerField.vue?vue&type=template&id=ce2519b0"
import script from "./BDatePickerField.vue?vue&type=script&lang=js"
export * from "./BDatePickerField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports